import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { withAuth, Security, ImplicitCallback } from '@okta/okta-react';

const envs = {
  production_oktapreview: {
    issuer: 'https://iress.oktapreview.com',
    clientId: '0oapomn4ye6Trviji0h7',
  },
  production: {
    issuer: 'https://iress.okta.com',
    clientId: '0oa1icyospmj5gUeB0h8',
  },
  development: {
    issuer: 'https://dev-597287.okta.com/oauth2/default',
    clientId: '0oa2ome8euxkDzJb2357',
  },
};

const config = envs[process.env.NODE_ENV];

const ReLogin = withAuth(function ReLogin({ auth }) {
  auth.logout('/');
  return <span>Logging out...</span>;
});

const OktaAuth = ({ children }) => (
  <Router>
    <Security
      {...config}
      redirectUri={window.location.origin + '/oauth/callback'}>
      {children}
      <Route path="/oauth/callback" component={ImplicitCallback} />
      <Route path="/oauth/login" component={ReLogin} />
    </Security>
  </Router>
);

export default OktaAuth;
